import { DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { X } from '../../../../icons/x';
import STRING_KEYS from '../../../../language/keys';
import { SelectIconModalTitleStyle } from './style';

type SelectIconModalTitleProps = {
    onClick:() => void,
}

export default function SelectIconModal({ onClick }:SelectIconModalTitleProps): JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <DialogTitle style={ SelectIconModalTitleStyle.title }>
      <Typography
        variant="h6"
        style={ SelectIconModalTitleStyle.header }
      >
        {translate(STRING_KEYS.CHOOSE_ICON)}
      </Typography>
      <X
        onClick={ onClick }
        style={ SelectIconModalTitleStyle.close.style }
        sx={ SelectIconModalTitleStyle.close.sx }
      />
    </DialogTitle>
  );
}
